<template>
  <div id="bookingForm">
    <!-- HEADER BOX -->
    <div class="currentSection">
      <div class="sectionBox" :class="{ 'oneColumn' : panel == 4}">
        <p @click="subtractFromPanel()" style="cursor: pointer" v-if="panel < 4">&#10094;</p>
        <div class="panelsDisplay">
          <h2 v-show="panel == 0">Guests</h2>
          <h2 v-show="panel == 1">Date &amp; Time</h2>
          <h2 v-show="panel == 2">Contact Details</h2>
          <h2 v-show="panel == 3">Review</h2>
          <h2 v-show="panel == 4">Order Complete</h2>
        </div>
        <p @click="addToPanel()" style="cursor: pointer" v-if="panel < 3">&#10095;</p>
      </div>
    </div>

    <!-- FORM -->
    <div class="bookingForm">
      <div class="formWrapper">


        <!-- PANEL 1: GUEST SELECTOR -->
        <div class="guestSelector" v-show="panel == 0">
          <div class="numberBox">
            <button
              class="guestsBtn"
              @click="getGuestsValue($event)"
              value="1"
              :class="{ 'selectedGuestsValue' : guestsVal == 1 }"
            >1</button>
          </div>
          <div class="numberBox">
            <button
              class="guestsBtn"
              @click="getGuestsValue($event)"
              value="2"
              :class="{ 'selectedGuestsValue' : guestsVal == 2 }"
            >2</button>
          </div>
          <div class="numberBox">
            <button
              class="guestsBtn"
              @click="getGuestsValue($event)"
              value="3"
              :class="{ 'selectedGuestsValue' : guestsVal == 3 }"
            >3</button>
          </div>
          <div class="numberBox">
            <button
              class="guestsBtn"
              @click="getGuestsValue($event)"
              value="4"
              :class="{ 'selectedGuestsValue' : guestsVal == 4 }"
            >4</button>
          </div>
          <div class="numberBox">
            <button
              class="guestsBtn"
              @click="getGuestsValue($event)"
              value="5"
              :class="{ 'selectedGuestsValue' : guestsVal == 5 }"
            >5</button>
          </div>
          <div class="numberBox">
            <button
              class="guestsBtn"
              @click="getGuestsValue($event)"
              value="6"
              :class="{ 'selectedGuestsValue' : guestsVal == 6 }"
            >6</button>
          </div>
        </div>
        <button
          v-show="panel == 0"
          id="contactForm"
          class="proceedBtn"
          :class="{ 'disabled' : !guestsVal }"
          :disabled="!guestsVal"
          @click="addToPanel()"
        >Proceed</button>


        <!-- PANEL 2: CALENDAR -->
        <div id="calendar" v-show="panel == 1">
          <div class="month">
            <ul>
              <li class="prev" @click="subtractMonth">&#10094;</li>
              <li class="next" @click="addMonth">&#10095;</li>
              <li class="monthSection">
                {{ month }}
                <b />
                <span>{{ year }}</span>
              </li>
            </ul>
          </div>

          <ul class="weekdays">
            <li v-for="weekday in weekdays" :key="weekday.id">{{ weekday }}</li>
          </ul>

          <ul class="daysChart">
            <li v-for="blank in firstDayOfMonth" :key="blank.id">&nbsp;</li>
            <li
              v-for="date in daysInMonth"
              v-bind:key="date.id"
              class="days"
              :class="[
              { 'currentDay' : date == initialDate && month == initialMonth && year == initialYear },
              { 'selectedDay' : date == selected }]"
              @click="[selected = date, newDateSelected($event)]"
            >
              <span>{{ date }}</span>
            </li>
          </ul>
        </div>
        <div class="buttonGrid" v-show="panel == 1">
          <button
            value="5:30PM"
            class="timeBtn"
            :class="{ 'selectedTime' : activeBtn == 'btn1' }"
            @click="[activeBtn = 'btn1', bookingTime($event)]"
          >5:30pm</button>

          <button
            value="9:30PM"
            class="timeBtn"
            :class="{ 'selectedTime' : activeBtn == 'btn2' }"
            @click="[activeBtn = 'btn2', bookingTime($event)]"
          >9:30pm</button>
        </div>
        <button
          v-show="panel == 1"
          id="contactForm"
          class="proceedBtn"
          :class="{ 'disabled' : !timeVal }"
          :disabled="!timeVal"
          @click="addToPanel()"
        >Proceed</button>


        <!-- PANEL 3: CONTACT DETAILS -->
        <div class="contactDetails" v-show="panel == 2">
          <div class="inputGrid">
            <input
              type="text"
              placeholder="first name"
              autofocus
              required
              v-model="contactForm.firstName"
            />
            <input type="text" placeholder="last name" required v-model="contactForm.lastName" />
          </div>
          <input type="email" placeholder="email" required v-model="contactForm.email" />

          <span
            style="color: red; font-size: 10px"
            v-if="contactForm.confirmEmail != contactForm.email"
          >Email does not match.</span>
          <input
            type="email"
            placeholder="confirm email"
            required
            autocomplete="off"
            v-model="contactForm.confirmEmail"
          />

          <vue-tel-input v-model="contactForm.phone"></vue-tel-input>
        </div>
        <button
          v-show="panel == 2"
          id="contactForm"
          class="proceedBtn"
          :class="{ 'disabled' :  !contactForm }"
          :disabled="!contactForm"
          @click="addToPanel()"
        >Proceed</button>


        <!-- PANEL 4: REVIEW -->
        <div class="review" v-show="panel == 3">
          <div class="textBox4">
            <h4>Your Reservation</h4>
            <h2>Confirm your details</h2>
            <p>After your details are confirmed, we will email you these details. In case of no shows and same day cancellation, 
              the restaurant reserves the right to charge the guest's credit card THB 3,766.40 per person upon the booking.</p>
          </div>

          <div class="detailsEntryGrid">
            <div class="detailEntry">
              <h5>Guests</h5>
              <p class="enteredInput" v-if="guestsVal">{{ guestsVal }} People</p>
              <p class="enteredInput notFilled" v-else>Not Filled!</p>
            </div>

            <div class="detailEntry">
              <h5>Time &amp; Date</h5>
              <p
                class="enteredInput"
                v-if="reservationDate && timeVal"
              >{{ reservationDate }} @ {{ timeVal }}</p>
              <p class="enteredInput notFilled" v-else>Not Filled!</p>
            </div>
          </div>
          <div class="detailEntry">
            <h5>Full Name</h5>
            <p
              class="enteredInput"
              v-if="contactForm.firstName && contactForm.lastName"
            >{{ contactForm.firstName }} {{ contactForm.lastName }}</p>
            <p class="enteredInput notFilled" v-else>Not Filled!</p>
          </div>
          <div class="detailEntry">
            <h5>E-mail Address</h5>
            <p class="enteredInput" v-if="contactForm.email">{{ contactForm.email }}</p>
            <p class="enteredInput notFilled" v-else>Not Filled!</p>
          </div>
          <div class="detailEntry">
            <h5>Phone Number</h5>
            <p class="enteredInput" v-if="contactForm.phone">{{ contactForm.phone }}</p>
            <p class="enteredInput notFilled" v-else>Not Filled!</p>
          </div>
        </div>
        <button
          v-show="panel == 3"
          id="contactForm"
          class="proceedBtn"
          :class="{ 'disabled' : !guestsVal || !reservationDate || !timeVal || !contactForm.firstName || !contactForm.lastName || !contactForm.email || !contactForm.confirmEmail || !contactForm.phone }"
          :disabled="!guestsVal || !reservationDate || !timeVal || !contactForm.firstName || !contactForm.lastName || !contactForm.email || !contactForm.confirmEmail || !contactForm.phone"
          @click="submitForm($event), addToPanel()"
        >submit reservation</button>


        <!-- PANEL 5: CONFIRMED -->
        <div class="confirmed" v-show="panel == 4">
          <h4>Thank you {{ contactForm.firstName }}!</h4>
          <h2>We will be preparing your table for <span>{{ reservationDate }}.</span></h2>
          <p>Please show up 30 minutes before your {{ timeVal }} reservation time so we 
            can take an accurate account of all the attendees and guests who will be 
            dining with us that night. We look forward to serving you!</p>
        </div>
        

        <p class="bookingDisclaimer" v-show="panel < 3">
          Have more than 6 guests?
          <a href="tel: 954-594-3160">
            <u>call us</u>
          </a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import moment from "moment";

export default {
  name: "bookingForm",
  components: {
    firebase,
    moment
  },
  data() {
    return {
      panel: 0,
      guestsVal: "",
      today: moment(),
      dateContext: moment(),
      weekdays: ["S", "M", "T", "W", "T", "F", "S"],
      selected: "",
      selectedDate: moment().format("MM/DD/YYYY"),
      reservationDate: "",
      timeVal: "",
      activeBtn: "",
      contactForm: {
        firstName: "",
        lastName: "",
        email: "",
        confirmEmail: "",
        phone: ""
      }
    };
  },
  computed: {
    year() {
      var t = this;
      return t.dateContext.format("Y");
    },
    month() {
      var t = this;
      return t.dateContext.format("MMMM");
    },
    numberedMonth() {
      var t = this;
      return t.dateContext.format("MM");
    },
    daysInMonth() {
      var t = this;
      return t.dateContext.daysInMonth();
    },
    currentDate() {
      var t = this;
      return t.dateContext.get("date");
    },
    firstDayOfMonth() {
      var t = this;
      var firstDay = moment(t.dateContext).subtract(t.currentDate - 1, "days");
      return firstDay.weekday();
    },
    initialDate() {
      var t = this;
      return t.today.get("date");
    },
    initialMonth() {
      var t = this;
      return t.today.format("MMMM");
    },
    initialMonthNumber() {
      var t = this;
      return t.today.format("MM");
    },
    initialYear() {
      var t = this;
      return t.today.format("Y");
    },
    dayFormat() {
      var t = this;
      t.reservationDate = t.selected + "/" + t.numberedMonth + "/" + t.year;
      console.log(t.reservationDate);
    }
  },
  methods: {
    addToPanel(e) {
      let t = this;
      if (t.panel < 4) {
        t.panel++;
      }
    },
    subtractFromPanel(e) {
      let t = this;
      if (t.panel > 0) {
        t.panel--;
      }
    },
    getGuestsValue(e) {
      e.preventDefault;
      this.guestsVal = e.target.value;
    },
    addMonth() {
      var t = this;
      t.dateContext = moment(t.dateContext).add(1, "month");
    },
    subtractMonth() {
      var t = this;
      t.dateContext = moment(t.dateContext).subtract(1, "month");
    },
    newDateSelected(e) {
      var t = this;
      t.reservationDate = t.selected + "/" + t.numberedMonth + "/" + t.year;
      console.log(t.reservationDate);
    },
    bookingTime(e) {
      var t = this;
      t.timeVal = e.target.value;
    },
    submitForm(e) {
      e.preventDefault();
      console.log('works')
      //this.saveReservation();
    },
    saveReservation(guests, reservation, contactDetails) {
      let newReservationReq = this.$reservationRequests.push();
      newReservationReq.set({
        guests: this.guestsVal,
        reservation: this.reservationDate + " @ " + this.timeVal,
        contactDetails: this.contactForm
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/componentStyles/bookingForm.scss";
</style>